module.exports = __webpack_public_path__ + "img/welfare-2.ab315aef.png";